import { lazy } from 'react';
import { PurchaseModalLoading } from '@/components/purchase-sheet';
import { LazyPanelBoundary } from '@/features/billing';
import { addFundsRequest } from './add-funds-request';

const LazyAddFundsPanel = lazy(() => import('./add-funds-panel').then((module) => ({ default: module.AddFundsPanel })));

export function AddFundsHost() {
  const request = addFundsRequest.useRequestState();
  const isOpen = addFundsRequest.useIsOpen();
  addFundsRequest.useHost();

  return (
    <LazyPanelBoundary
      resetKey={request?.key}
      onLoadError={() => addFundsRequest.dismiss()}
      fallback={
        <PurchaseModalLoading
          isOpen={isOpen}
          onClose={() => addFundsRequest.dismiss()}
          onCloseComplete={addFundsRequest.clear}
        />
      }
    >
      {request == null ? null : (
        <LazyAddFundsPanel
          key={request.key}
          isOpen={isOpen}
          onCloseComplete={addFundsRequest.clear}
          data={request.data}
          onConfirm={addFundsRequest.confirm}
          onClose={addFundsRequest.dismiss}
          onBusyChange={addFundsRequest.setBusy}
        />
      )}
    </LazyPanelBoundary>
  );
}
